export default "__VITE_ASSET__Cn7H4ODp__"